import type { RelationshipType } from './ScientificRelationship';
import type { RelationshipDirection } from './relationshipApi';

const LABELS: Record<RelationshipType, Record<RelationshipDirection, string>> = {
  ENCODES: { outgoing: 'Encodes', incoming: 'Encoded by' },
  HAS_TRANSCRIPT: { outgoing: 'Transcripts', incoming: 'Transcript of' },
  TRANSLATES_TO: { outgoing: 'Translates to', incoming: 'Translated from' }
};

export function relationshipHeading(type: RelationshipType, direction: RelationshipDirection): string {
  return LABELS[type][direction];
}
